export function dateKey(date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

export function dailyChallengeSeed(date = new Date()): number {
  const key = `treasure-grid:${dateKey(date)}`;
  let hash = 2166136261;
  for (const character of key) {
    hash ^= character.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
